const data = {
	"width": 24,
	"height": 24,
	"body": "<path fill=\"currentColor\" d=\"M6 18V6h2v12H6m3.5-6L18 6v12l-8.5-6Z\"/>"
};
exports.__esModule = true;
exports.default = data;
